import PageWrapper from "@/components/atoms/PageWrapper"
import { OrganizationHeaderButtons } from "@/components/molecules/OrganizationHeaderButtons"
import { Separator } from "@/components/ui/separator"
import { useGetOrganisationCrmList } from "@/features/crm/hooks/useQuery/useGetOrganisationCrmList"
import { useCrmConfigsByCrmProjectId } from "@/features/crm_config/hooks/useQuery/useCrmConfigsByCrmProjectId"
import { Tables } from "@/lib/supabase/supabase_types"
import { useGetCrmProjectsByCrmId } from "@/features/crm_project/hooks/useQuery/useGetCrmProjectsByCrmId"
import { useGetOrganizationById } from "@/features/organization/hooks/useQuery/useGetOrganizationById"
import { useOrganizationStore } from "@/lib/zustand/useStore"
import { ManageOrganizationSecondaryTabs, ManageOrganizationTabs } from "@/pages/ManageOrganization/ManageOrganizationContext"
import { ManageOrganizationProvider } from "@/pages/ManageOrganization/ManageOrganizationProvider"
import { useLocalStorage } from "@uidotdev/usehooks"
import { parseAsInteger, parseAsStringEnum, useQueryState } from "nuqs"
import { ReactNode, useEffect, useState } from "react"
import { Outlet, useParams } from "react-router-dom"


export function RedirectManageOrganizationWithLayout() {
    /* 
    * Redirect
    */
    const {
        organization: storeOrganization,
        setOrganization
    } = useOrganizationStore()
    const { orgId } = useParams()
    const [localStorageOrgId, setLocalStorageOrgId] = useLocalStorage('orgId', orgId)

    const { data: organization, isLoading } = useGetOrganizationById(Number(localStorageOrgId))

    // const location = useLocation()
    // const navigate = useNavigate()

    // TODO: This code wasn't working as expected, so I commented it out. 
    // It was switching the organization in the URL to the one in local storage.
    // It was causing an infinite loop.
    useEffect(() => {
        if (isLoading) return
        if (!storeOrganization && organization) {
            setLocalStorageOrgId(organization.id.toString())
            setOrganization(organization)
        }
    }, [storeOrganization, organization, setOrganization, setLocalStorageOrgId, isLoading])
    /**
       * * Data for Tabs / Provider
    */
    const [crm, setCrm] = useState<Tables<'crm'> | null>(null)
    const [crmId, setCrmId] = useQueryState('crmId', parseAsInteger)
    const [crmProject, setCrmProject] = useState<Tables<'crm_project'> | null>(null)
    const [crmProjectId, setCrmProjectId] = useQueryState('crmProjectId', parseAsInteger)
    const [crmConfig, setCrmConfig] = useState<Tables<'crm_config'> | null>(null)
    const [crmConfigId, setCrmConfigId] = useQueryState('crmConfigId', parseAsInteger)

    const [aboveLayout, setAboveLayout] = useState<ReactNode>()

    const handleSetCrm = (crm: Tables<'crm'> | null) => {
        setCrm(crm)
        setCrmId(crm ? crm.id : null)
        setCrmProject(null)
        setCrmProjectId(null)
    }
    const handleSetCrmProject = (crmProject: Tables<'crm_project'> | null) => {
        setCrmProject(crmProject)
        setCrmProjectId(crmProject ? crmProject.id : null)
        setCrmConfig(null)
        setCrmConfigId(null)
    }
    const handleSetCrmConfig = (crmConfig: Tables<'crm_config'> | null) => {
        setCrmConfig(crmConfig)
        setCrmConfigId(crmConfig ? crmConfig.id : null)
    }
    /**
       * * Manage Tabs
    */
    const [currentTab, setCurrentTab] = useQueryState(
        'currentTab',
        parseAsStringEnum<ManageOrganizationTabs>(Object.values(ManageOrganizationTabs)).withDefault(ManageOrganizationTabs.crm)
    )
    const [secondaryTab, setSecondaryTab] = useQueryState(
        'secondaryTab',
        parseAsStringEnum<ManageOrganizationSecondaryTabs>(Object.values(ManageOrganizationSecondaryTabs)).withDefault(ManageOrganizationSecondaryTabs.settings)
    )
    const crmsData = useGetOrganisationCrmList(storeOrganization?.id)
    const crmProjectsData = useGetCrmProjectsByCrmId(crmId as number | undefined)
    const crmConfigsData = useCrmConfigsByCrmProjectId(crmProjectId as number | undefined)
    useEffect(() => {
        if (crmsData.isLoading) return
        if (crmId && !crm) {
            const crm = crmsData.data?.find(crm => crm?.id === crmId)
            setCrm(crm!)
        }
    }, [crmId, setCrm, crm, crmsData])
    useEffect(() => {
        if (crmProjectsData.isLoading) return
        if (crmProjectId && !crmProject) {
            const crmProject = crmProjectsData.data?.find(crmProject => crmProject?.id === crmProjectId)
            setCrmProject(crmProject!)
        }
    }, [crmProjectId, setCrmProject, crmProject, crmProjectsData])
    useEffect(() => {
        if (crmConfigsData.isLoading) return
        if (crmConfigId && !crmConfig) {
            const crmConfig = crmConfigsData.data?.find(crmConfig => crmConfig?.id === crmConfigId)
            setCrmConfig(crmConfig!)
        }
    }, [crmConfigId, setCrmConfig, crmConfig, crmConfigsData])

    useEffect(() => {
        setCrm(null);
    }, [storeOrganization]);
    /**
       * * Update Organization Name
    */
    
    

    return (
        <ManageOrganizationProvider value={{
            crm,
            crmId,
            setCrm: handleSetCrm,
            crmProject,
            crmProjectId,
            setCrmProject: handleSetCrmProject,
            crmConfig,
            crmConfigId,
            setCrmConfig: handleSetCrmConfig,
            currentTab,
            setCurrentTab,
            crmsData,
            crmProjectsData,
            crmConfigsData,
            aboveLayout,
            setAboveLayout,
            secondaryTab,
            setSecondaryTab,
        }}>
            <PageWrapper className="flex-col">
                <div className="flex flex-col flex-1 w-full gap-2 ">
                    {aboveLayout}
                    <div className="flex items-center justify-between">
                        <div className="">
                            <p className="text-xs">Organization</p>
                            <p className="text-lg">{storeOrganization?.name}</p>
                        </div>
                        <OrganizationHeaderButtons />
                    </div>
                    <Separator />
                    <Outlet />
                </div >
            </PageWrapper >
        </ManageOrganizationProvider >
    )
}
